import { combineReducers } from 'redux'
import foodsAndBeverages from './foodsAndBeverages'

const forms = combineReducers({
  foodsAndBeverages
})

export default forms
